module.exports = __webpack_public_path__ + "img/C-top.cceccbeb.png";